import { createSlice } from '@reduxjs/toolkit';
import { initialState } from '../../../../data/entitlement/sites/notes/initialState.notes.data';

const NotesSlice = createSlice({
  name: 'notes',
  initialState,
  reducers: {
    setAddNewNote: (state, action) => {
      state.isAddNewNote = action.payload
        ? action.payload
        : initialState.isAddNewNote;
    },
  },
});

export const { setAddNewNote } = NotesSlice.actions;
export default NotesSlice.reducer;
